import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    minutes,
    seconds,
    isExpired
  } = useCountdown();
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Recibirás acceso inmediato para descargar todo el contenido.'
  }, {
    q: '¿Funciona para cualquier país?',
    a: 'Sí. Las actividades pueden aplicarse fácilmente en cualquier programa escolar.'
  }, {
    q: '¿Necesito mucho equipamiento?',
    a: 'No. Muchas actividades están pensadas para trabajar incluso con pocos recursos.'
  }, {
    q: '¿Puedo usarlo con distintos cursos?',
    a: 'Sí. Las actividades incluyen variaciones según edad y nivel.'
  }, {
    q: '¿El material es descargable?',
    a: 'Sí. Todo el contenido se entrega en formato digital listo para usar.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 30 días de garantía total.'
  }];
  return <section className="py-20 bg-[#143524]" data-id="element-138">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-139">
        <div className="text-center mb-12" data-id="element-140">
          <h2 className="text-3xl font-black text-white" data-id="element-141">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4 mb-16" data-id="element-142">
          {faqs.map((faq, index) => <div key={index} className="border border-[#1E4D2B] rounded-lg overflow-hidden bg-[#0C2818]" data-id="element-143">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 hover:bg-gray-800/50 transition-colors text-left" data-id="element-144">
                <span className="font-bold text-gray-200 text-lg" data-id="element-145">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#FBBF24]" data-id="element-146" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-147" />}
              </button>

              <AnimatePresence data-id="element-148">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-149">
                    <div className="p-5 text-gray-400 border-t border-[#1E4D2B]" data-id="element-150">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        {/* Final CTA Block */}
        <div className="text-center bg-[#0C2818] rounded-3xl p-8 md:p-12 border border-[#16A34A]/30 shadow-2xl relative overflow-hidden" data-id="element-151">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,#16A34A_0%,transparent_60%)] opacity-10 pointer-events-none" data-id="element-152"></div>

          <div className="relative z-10" data-id="element-153">
            <a href="https://pay.hotmart.com/J104331849I?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#16A34A] hover:bg-[#15803D] text-white font-black text-xl md:text-2xl py-5 px-10 rounded-full shadow-[0_0_30px_rgba(22,163,74,0.4)] hover:shadow-[0_0_40px_rgba(22,163,74,0.6)] transform hover:scale-105 transition-all duration-300 w-full md:w-auto mb-6" data-id="element-154">
              QUIERO MI MEGAPACK AHORA 🚀
            </a>

            <div className="flex flex-col items-center justify-center gap-2" data-id="element-155">
              <span className="text-gray-400 font-medium" data-id="element-156">
                Contador de oferta activo:
              </span>
              <span className="bg-[#E63946] text-white px-3 py-1 rounded font-mono text-xl font-bold tracking-wider" data-id="element-157">
                {!isExpired ? `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}` : '00:00'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}